import {
  getInt32,
  getObject,
} from "@surya-digital/leo-ts-types";
import { ProjectSortOrder } from "./projectSortOrder";


export namespace GetActiveResearcherProjectsSortOrderEnums {
  /* eslint-disable @typescript-eslint/no-shadow */
  export namespace ColumnName {
    export enum ColumnName {
      PROJECT_NAME = "PROJECT_NAME",
      CREATED_ON = "CREATED_ON",
      LAST_MODIFIED = "LAST_MODIFIED",
    }
  
    export interface ColumnNameDTO {
      case: string;
    }
  
    export const fromDTO = (dto: ColumnNameDTO): ColumnName => {
      if (dto === undefined || dto === null) {
        throw new InvalidGetActiveResearcherProjectsSortOrderColumnNameError(
          `Invalid DTO ${dto} provided for ColumnName.ColumnName`
        );
      }
      switch (dto.case) {
        case "PROJECT_NAME":
          return ColumnName.PROJECT_NAME;
        case "CREATED_ON":
          return ColumnName.CREATED_ON;
        case "LAST_MODIFIED":
          return ColumnName.LAST_MODIFIED;
        default:
          throw new InvalidGetActiveResearcherProjectsSortOrderColumnNameError(
            `Case ${dto.case} is not valid case of ColumnName.ColumnName`
          );
      }
    };
  
    export const toDTO = (columnName: ColumnName): ColumnNameDTO => {
      const enumDTO = {
        case: ColumnName[columnName],
      };
      return enumDTO;
    };
  }
  
}
export interface GetActiveResearcherProjectsSortOrderDTO {
  sortIndex: number;
  columnName: GetActiveResearcherProjectsSortOrderEnums.ColumnName.ColumnNameDTO;
  order: ProjectSortOrder.ProjectSortOrderDTO;
}

export class GetActiveResearcherProjectsSortOrder {
  readonly isGetActiveResearcherProjectsSortOrderGetActiveResearcherProjectsSortOrder: boolean = true;

  readonly sortIndex: number;
  readonly columnName: GetActiveResearcherProjectsSortOrderEnums.ColumnName.ColumnName;
  readonly order: ProjectSortOrder.ProjectSortOrder;


  constructor(
  sortIndex: number, 
  columnName: GetActiveResearcherProjectsSortOrderEnums.ColumnName.ColumnName, 
  order: ProjectSortOrder.ProjectSortOrder
  ) {
    this.sortIndex = sortIndex;
    this.columnName = columnName;
    this.order = order;
  }

  static fromDTO(dto: GetActiveResearcherProjectsSortOrderDTO): GetActiveResearcherProjectsSortOrder {
    const sortIndex = getInt32(dto, "sortIndex", InvalidGetActiveResearcherProjectsSortOrderSortIndexError);
    const columnName = GetActiveResearcherProjectsSortOrderEnums.ColumnName.fromDTO(getObject(dto, "columnName", InvalidGetActiveResearcherProjectsSortOrderColumnNameError));
    const order = ProjectSortOrder.fromDTO(getObject(dto, "order", InvalidGetActiveResearcherProjectsSortOrderOrderError));
    return new GetActiveResearcherProjectsSortOrder(
      sortIndex,
      columnName,
      order
    );
  }

  toDTO(): GetActiveResearcherProjectsSortOrderDTO {
    const dto: GetActiveResearcherProjectsSortOrderDTO = {
        sortIndex: this.sortIndex,
        columnName: GetActiveResearcherProjectsSortOrderEnums.ColumnName.toDTO(this.columnName),
        order: ProjectSortOrder.toDTO(this.order)
    };
    return dto;
  }
  }

GetActiveResearcherProjectsSortOrder.prototype.toString = function toString(): string {
  return `GetActiveResearcherProjectsSortOrder(sortIndex='${this.sortIndex}',columnName='${this.columnName}',order='${this.order}')`;
};

export class InvalidGetActiveResearcherProjectsSortOrderError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetActiveResearcherProjectsSortOrderError";
  }
}
export class InvalidGetActiveResearcherProjectsSortOrderSortIndexError extends InvalidGetActiveResearcherProjectsSortOrderError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetActiveResearcherProjectsSortOrderSortIndexError";
  }
}

export class InvalidGetActiveResearcherProjectsSortOrderColumnNameError extends InvalidGetActiveResearcherProjectsSortOrderError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetActiveResearcherProjectsSortOrderColumnNameError";
  }
}

export class InvalidGetActiveResearcherProjectsSortOrderColumnNameProjectNameError extends InvalidGetActiveResearcherProjectsSortOrderColumnNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetActiveResearcherProjectsSortOrderColumnNameProjectNameError";
  }
}

export class InvalidGetActiveResearcherProjectsSortOrderColumnNameCreatedOnError extends InvalidGetActiveResearcherProjectsSortOrderColumnNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetActiveResearcherProjectsSortOrderColumnNameCreatedOnError";
  }
}

export class InvalidGetActiveResearcherProjectsSortOrderColumnNameLastModifiedError extends InvalidGetActiveResearcherProjectsSortOrderColumnNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetActiveResearcherProjectsSortOrderColumnNameLastModifiedError";
  }
}

export class InvalidGetActiveResearcherProjectsSortOrderOrderError extends InvalidGetActiveResearcherProjectsSortOrderError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetActiveResearcherProjectsSortOrderOrderError";
  }
}
